export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";

export const UPDATE_DIFFICULTY = "UPDATE_DIFFICULTY";
export const UPDATE_SOLVED = "UPDATE_SOLVED";

export const FETCH_QUESTIONS = "FETCH_QUESTIONS";

export const CHECK_LOADING = "CHECK_LOADING";
export const MAIN_LOADING = "MAIN_LOADING";

export const UPDATE_FILTER_FAV = "UPDATE_FILTER_FAV";
export const UPDATE_FILTER_TOPIC = "UPDATE_FILTER_TOPIC";

export const UPDATE_FILTER_SOLVED = "UPDATE_FILTER_SOLVED";
export const UPDATE_SEARCH_STRING = "UPDATE_SEARCH_STRING";

export const UPDATE_FAVOURITE = "UPDATE_FAVOURITE";

export const UPDATE_QUESTION_LIST = "UPDATE_QUESTION_LIST";
